import type { IconProps } from './types';

export function Chinelo({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <path d="M128 32 Q72 32 64 96 Q60 144 76 196 Q88 224 128 224 Q168 224 180 196 Q196 144 192 96 Q184 32 128 32 Z" />
      <circle cx="128" cy="64" r="10" />
      <path d="M128 80 Q128 100 128 120" />
      <path d="M128 120 Q108 144 88 168" />
      <path d="M128 120 Q148 144 168 168" />
    </svg>
  );
}
